import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function MenuClosed({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <MenuClosed.Outline {...props} />
  ) : (
    <MenuClosed.Solid {...props} />
  );
}

MenuClosed.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <path
        d="M22.6357 4H7.62894C6.8786 4 6.26469 4.6 6.26469 5.33333C6.26469 6.06667 6.8786 6.66667 7.62894 6.66667H22.6357C23.3861 6.66667 24 6.06667 24 5.33333C24 4.6 23.3861 4 22.6357 4ZM22.6357 10.6667H11.7217C10.9714 10.6667 10.3574 11.2667 10.3574 12C10.3574 12.7333 10.9714 13.3333 11.7217 13.3333H22.6357C23.3861 13.3333 24 12.7333 24 12C24 11.2667 23.3861 10.6667 22.6357 10.6667ZM24 18.6667C24 17.9333 23.3861 17.3333 22.6357 17.3333H7.62894C6.8786 17.3333 6.26469 17.9333 6.26469 18.6667C6.26469 19.4 6.8786 20 7.62894 20H22.6357C23.3861 20 24 19.4 24 18.6667ZM0.398391 8.16L4.32744 12L0.398391 15.84C0.272085 15.9634 0.171894 16.11 0.103538 16.2713C0.035182 16.4326 3.52161e-09 16.6054 0 16.78C-3.52055e-09 16.9546 0.035182 17.1274 0.103538 17.2887C0.171894 17.45 0.272085 17.5966 0.398391 17.72C0.524696 17.8434 0.674641 17.9414 0.839667 18.0082C1.00469 18.075 1.18157 18.1094 1.36019 18.1094C1.53881 18.1094 1.71569 18.075 1.88071 18.0082C2.04574 17.9414 2.19568 17.8434 2.32199 17.72L7.21966 12.9333C7.34614 12.81 7.44647 12.6635 7.51493 12.5022C7.58339 12.3409 7.61863 12.168 7.61863 11.9933C7.61863 11.8187 7.58339 11.6458 7.51493 11.4845C7.44647 11.3232 7.34614 11.1767 7.21966 11.0533L2.32199 6.26667C1.78993 5.74667 0.93045 5.74667 0.398391 6.26667C-0.120026 6.78667 -0.133669 7.64 0.398391 8.16Z"
        className="icon-primary"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

MenuClosed.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <path
        d="M22.6357 4H7.62894C6.8786 4 6.26469 4.6 6.26469 5.33333C6.26469 6.06667 6.8786 6.66667 7.62894 6.66667H22.6357C23.3861 6.66667 24 6.06667 24 5.33333C24 4.6 23.3861 4 22.6357 4ZM22.6357 10.6667H11.7217C10.9714 10.6667 10.3574 11.2667 10.3574 12C10.3574 12.7333 10.9714 13.3333 11.7217 13.3333H22.6357C23.3861 13.3333 24 12.7333 24 12C24 11.2667 23.3861 10.6667 22.6357 10.6667ZM24 18.6667C24 17.9333 23.3861 17.3333 22.6357 17.3333H7.62894C6.8786 17.3333 6.26469 17.9333 6.26469 18.6667C6.26469 19.4 6.8786 20 7.62894 20H22.6357C23.3861 20 24 19.4 24 18.6667ZM0.398391 8.16L4.32744 12L0.398391 15.84C0.272085 15.9634 0.171894 16.11 0.103538 16.2713C0.035182 16.4326 3.52161e-09 16.6054 0 16.78C-3.52055e-09 16.9546 0.035182 17.1274 0.103538 17.2887C0.171894 17.45 0.272085 17.5966 0.398391 17.72C0.524696 17.8434 0.674641 17.9414 0.839667 18.0082C1.00469 18.075 1.18157 18.1094 1.36019 18.1094C1.53881 18.1094 1.71569 18.075 1.88071 18.0082C2.04574 17.9414 2.19568 17.8434 2.32199 17.72L7.21966 12.9333C7.34614 12.81 7.44647 12.6635 7.51493 12.5022C7.58339 12.3409 7.61863 12.168 7.61863 11.9933C7.61863 11.8187 7.58339 11.6458 7.51493 11.4845C7.44647 11.3232 7.34614 11.1767 7.21966 11.0533L2.32199 6.26667C1.78993 5.74667 0.93045 5.74667 0.398391 6.26667C-0.120026 6.78667 -0.133669 7.64 0.398391 8.16Z"
        className="icon-primary"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
